<template>
  <div class="bg-stand" style="height: 100%; overflow-y: hidden">
    <top-header></top-header>
    <div class="container-fluid">
      <div class="col-12">
        <div class="row top-navbar">
          <div class="col-6 pl-0">
            <h6 class="mb-2">{{ current_title }}</h6>
            <p class="m-0 d-flex align-items-center flex-row">
              <img
                src="@/assets/black-folder-icon.svg"
                width="20px"
                height="18px"
              />
              <span class="ml-2"
                >{{ total_folders }}
                <template v-if="total_folders > 1">folders</template
                ><template v-else>folder</template></span
              >
            </p>
          </div>
          <div class="col-6 pr-0 d-flex flex-row justify-content-end">
            <span class="user-search-icons" style="position: relative">
              <input
                type="text"
                placeholder="Search group folder"
                @input="searchuser"
                class="serach-user-box"
              />
              <img src="@/assets/SearchBar.svg" class="search-bar-icon" />
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid user-list-cover">
      <div class="users-list p-4">
        <div class="row mb-3">
          <div class="col-6 text-left">
            <span
              class="user-status-btn mr-1"
              :class="{ active: current_tab == 'request' }"
              @click="tab('request')"
            >
              Group Folder Request
            </span>
            <span
              class="user-status-btn mr-1"
              :class="{ active: current_tab == 'approved' }"
              @click="tab('approved')"
            >
              Approved Group Folders
            </span>
            <span
              class="user-status-btn mr-1"
              :class="{ active: current_tab == 'all' }"
              @click="tab('all')"
            >
              All Group Folders
            </span>
          </div>
          <div class="col-6 d-flex justify-content-end flex-row">
            <!--<span class="viewtype" :class="{'active': viewtype == 'grid'}" @click="set_viewtype('grid')">
                      <img src="@/assets/grid.svg" width="16px" height="16px" v-if="viewtype != 'grid'" />
                      <img src="@/assets/grid - blue.svg" width="16px" height="16px" v-if="viewtype == 'grid'" />
                    </span>
                    <span class="viewtype ml-3" :class="{'active': viewtype == 'list'}" @click="set_viewtype('list')">
                      <img src="@/assets/List.svg" width="16px" height="16px" v-if="viewtype != 'list'" />
                      <img src="@/assets/List - Blue.svg" width="16px" height="16px" v-if="viewtype == 'list'" />
                    </span>-->
          </div>
        </div>
        <div class="user-grid" v-if="folders.length && viewtype == 'grid'">
          <div
            class="grid-user-box mr-3 text-center"
            v-for="(user, index) in users"
            :key="index"
          >
            <div class="photo">
              <template v-if="user.data.photo">
                <span class="default-pic" @click="showprofile(user, index)">
                  <img :src="getPhoto(user.data.photo)" class="img-fluid" />
                </span>
              </template>
              <template v-if="!user.data.photo">
                <span @click="showprofile(user, index)" class="default-pic">{{
                  getName(user.names)
                }}</span>
              </template>
              <span
                class="user-badge"
                v-if="
                  !user.data.isActive && user.data.access_status == 'BLOCKED'
                "
                :class="{
                  blocked:
                    !user.data.isActive && user.data.access_status == 'BLOCKED',
                }"
                >Blocked</span
              >
              <span
                class="user-badge"
                v-if="
                  !user.data.isActive && user.data.access_status == 'ARCHIVED'
                "
                :class="{
                  archived:
                    !user.data.isActive &&
                    user.data.access_status == 'ARCHIVED',
                }"
                >Archived</span
              >
              <span
                class="user-badge"
                v-if="user.data.isActive"
                :class="{ active: user.data.isActive }"
                >Active</span
              >
            </div>
            <span class="edit-pen" @click="edit_user(index)">
              <img
                src="@/assets/Edit-User-Pen.svg"
                width="16px"
                height="16px"
              />
            </span>
            <div class="name">
              <h4 @click="showprofile(user, index)" class="profile-name">
                {{ user.names }} <span v-if="user.isSuperAdmin">(Admin)</span>
              </h4>
            </div>
            <p class="dept">
              {{ user.department }}
            </p>
            <div class="stat">
              <p>
                <img
                  src="@/assets/Calendar-Light.svg"
                  width="16px"
                  height="16px"
                />&nbsp;
                <span>{{ format(user.data.createdAt) }}</span>
              </p>
              <p>
                <img src="@/assets/Storage.svg" width="16px" height="16px" />
                <span class="text" v-if="user.storage == 'Unlimited'"
                  >&nbsp;{{ user.storage }}</span
                >
                <span class="text" v-if="user.storage != 'Unlimited'"
                  >&nbsp;{{ $sizeFormat(user.storage) }}</span
                >
              </p>
            </div>
            <div
              class="user-atn-btn"
              v-if="user.data.isActive || user.data.access_status == 'BLOCKED'"
            >
              <span
                v-if="!user.data.isActive"
                @click="unblockuser(index, user.data._id, user.names)"
              >
                <img
                  src="@/assets/Unblock-User.svg"
                  width="18px"
                  height="16px"
                />
                &nbsp;
                <span>Unblock</span>
              </span>
              <span
                v-if="user.data.isActive"
                @click="blockuser(index, user.data._id, user.names)"
              >
                <img
                  src="@/assets/Delete-User.svg"
                  width="18px"
                  height="16px"
                />
                &nbsp;
                <span>Block</span>
              </span>
              <span @click="delete_user(user.data._id, user.names, index)">
                <img src="@/assets/Delete-Btn.svg" width="16px" height="16px" />
                &nbsp;
                <span>Delete</span>
              </span>
            </div>
          </div>
        </div>
        <div
          class="row users-table"
          v-if="folders.length && viewtype == 'list'"
        >
          <div class="col-12 mt-4">
            <div class="group-folders" v-if="folders.length">
              <template v-if="current_tab == 'request'">
                <template v-if="group_folder_request.length">
                  <ul v-if="group_folder_request.length">
                    <li
                      v-for="(folder, index) in group_folder_request"
                      :key="index"
                      class="row"
                    >
                      <div class="col-3 d-flex align-items-center">
                        <img
                          src="@/assets/icons/folder/Group.svg"
                          height="28px"
                          width="auto"
                        />&nbsp;&nbsp;&nbsp;&nbsp;
                        <span class="folder_name">{{ folder.name }}</span>
                      </div>
                      <div class="col-3 text-left">
                        <span class="text-size">{{ folder.created }}</span>
                      </div>
                      <div class="col-2">
                        <span class="text-size"
                          >{{ folder.collaborators }} Collaborators</span
                        >
                      </div>
                      <div class="col-2 d-flex align-items-center">
                        <img src="@/assets/calendar-icon.svg" />&nbsp;
                        <span class="text-size">{{
                          format_date(folder.created_at)
                        }}</span>
                      </div>
                      <div class="actions col-2">
                        <span class="approve-btn" @click="approve(folder.id)"
                          >Approve</span
                        >&nbsp;&nbsp;
                        <span class="decline-btn" @click="decline(folder.id)"
                          >Decline</span
                        >
                      </div>
                    </li>
                  </ul>
                </template>
                <template v-else>
                  <div class="text-center w-100 mt-3">
                    <div>
                      <img src="@/assets/all-department-lllustration.svg" />
                    </div>
                    <div>
                      <h3 style="font-size: 22px; font-weight: bold">
                        No Group Folder Request
                      </h3>
                    </div>
                  </div>
                </template>
              </template>
              <template v-if="current_tab == 'approved'">
                <template v-if="approved_folder.length">
                  <ul v-if="approved_folder.length">
                    <li
                      v-for="(folder, index) in approved_folder"
                      :key="index"
                      class="row"
                    >
                      <div class="col-3 d-flex align-items-center">
                        <img
                          src="@/assets/icons/folder/Group.svg"
                          height="28px"
                          width="auto"
                        />&nbsp;&nbsp;&nbsp;&nbsp;
                        <span class="folder_name">{{ folder.name }}</span>
                      </div>
                      <div class="col-3 text-left">
                        <span class="text-size">{{ folder.created }}</span>
                      </div>
                      <div class="col-2">
                        <span class="text-size"
                          >{{ folder.collaborators }} Collaborators</span
                        >
                      </div>
                      <div class="col-2 d-flex align-items-center">
                        <img src="@/assets/calendar-icon.svg" />&nbsp;
                        <span class="text-size">{{
                          format_date(folder.created_at)
                        }}</span>
                      </div>
                      <div class="actions col-2">
                        <span class="approval_status">Approved</span>
                      </div>
                    </li>
                  </ul>
                </template>
                <template v-else>
                  <div class="text-center w-100 mt-3">
                    <div>
                      <img src="@/assets/all-department-lllustration.svg" />
                    </div>
                    <div>
                      <h3 style="font-size: 22px; font-weight: bold">
                        No Approved Group Folder
                      </h3>
                    </div>
                  </div>
                </template>
              </template>
              <template v-if="current_tab == 'all'">
                <template v-if="group_folder.length">
                  <ul v-if="group_folder.length">
                    <li
                      v-for="(folder, index) in group_folder"
                      :key="index"
                      class="row"
                    >
                      <div class="col-3 d-flex align-items-center">
                        <img
                          src="@/assets/icons/folder/Group.svg"
                          height="28px"
                          width="auto"
                        />&nbsp;&nbsp;&nbsp;&nbsp;
                        <span class="folder_name">{{ folder.name }}</span>
                      </div>
                      <div class="col-3 text-left">
                        <span class="text-size">{{ folder.created }}</span>
                      </div>
                      <div class="col-2">
                        <span class="text-size"
                          >{{ folder.collaborators }} Collaborators</span
                        >
                      </div>
                      <div class="col-2 d-flex align-items-center">
                        <img src="@/assets/calendar-icon.svg" />&nbsp;
                        <span class="text-size">{{
                          format_date(folder.created_at)
                        }}</span>
                      </div>
                      <div class="actions col-2">
                        <template v-if="!folder.is_approved">
                          <span class="approve-btn" @click="approve(folder.id)"
                            >Approve</span
                          >&nbsp;&nbsp;
                          <span class="decline-btn" @click="decline(folder.id)"
                            >Decline</span
                          >
                        </template>
                        <template v-else>
                          <span class="approval_status">Approved</span>
                        </template>
                      </div>
                    </li>
                  </ul>
                </template>
                <template v-else>
                  <div class="text-center w-100 mt-3">
                    <div>
                      <img src="@/assets/all-department-lllustration.svg" />
                    </div>
                    <div>
                      <h3 style="font-size: 22px; font-weight: bold">
                        No Group Folder
                      </h3>
                    </div>
                  </div>
                </template>
              </template>
            </div>
            <div class="loading" v-if="folder_loader">
              <svg
                width="120px"
                height="120px"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid"
                class="lds-dual-ring"
                style="background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%"
              >
                <circle
                  cx="50"
                  cy="50"
                  fill="none"
                  stroke-linecap="round"
                  r="20"
                  stroke-width="4"
                  stroke="#039aed"
                  stroke-dasharray="31.41592653589793 31.41592653589793"
                >
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    calcMode="linear"
                    values="0 50 50;360 50 50"
                    keyTimes="0;1"
                    dur="1s"
                    begin="0s"
                    repeatCount="indefinite"
                  ></animateTransform>
                </circle>
              </svg>
              Loading folders...
            </div>
          </div>
        </div>
      </div>
    </div>
    <login ref="login"></login>
    <loading ref="loading"></loading>
    <notify ref="notify"></notify>
    <logout ref="logout"></logout>
    <invite ref="invite"></invite>
  </div>
</template>
<style scoped>
.approval_status {
  background-color: #9ffcca !important;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 114px;
  height: 40px;
  font-size: 14px;
  border-radius: 8px !important;
  color: #5d696f;
}
.users-list {
  background: #fafafa;
  height: calc(100% - 125px);
  text-align: left;
  padding-top: 1em;
}
.folder_name {
  font-size: 15px;
  color: #111;
  font-weight: 600;
}

.users-list .row:first-child {
  height: auto !important;
}

.group-folders ul li {
  background: #fff;
  padding: 1em;
  border-radius: 8px;
  margin-bottom: 12px;
}

.text-size {
  font-size: 15px;
}

.approve-btn {
  background-color: #40d886 !important;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 114px;
  height: 40px;
  font-size: 14px;
  border-radius: 8px !important;
  color: #fff;
}

.decline-btn {
  background-color: transparent !important;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 114px;
  height: 40px;
  font-size: 14px;
  border-radius: 8px !important;
  border: 1px solid #fc6d6c !important;
  color: #fc6d6c !important;
}
.loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
button {
  outline: none;
}
.department {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.8em;
}
.department select {
  border: 1px solid #e1e1e1;
  padding: 0.8em 0.5em;
}
.assign {
  display: flex;
  flex-direction: row;
  font-size: 13px;
}
.assign input {
  margin-right: 0.4em;
}
.add-department .error {
  color: #fc6d6c;
}
.form {
  background: #f9f9f97e url("../../public/bg.png");
  height: calc(100% - 160px);
  text-align: left;
  padding: 1em;
}
.form ul li {
  display: flex;
  justify-content: space-evenly;
  margin-bottom: 20px;
}
.actions {
  display: flex;
  justify-content: space-around;
}
.actions button {
  border: none;
  border-radius: 5px;
  padding: 0 1.2em;
  font-size: 12px;
  height: 32px;
  color: #fff;
  box-shadow: rgba(0, 0, 0, 0.3) 0 3px 4px 0;
  outline: none;
}
.actions .approve_btn {
  background-color: #0071e0;
}
.actions .approve_btn:hover {
  background-color: rgb(4, 84, 165);
}
.actions .decline_btn {
  background-color: rgb(224, 52, 0);
}
.actions .decline_btn:hover {
  background-color: rgb(158, 35, 4);
}
.form .add-department {
  width: 30%;
}
.form .add-department h4 {
  font-weight: bold;
}
.form input[type="text"] {
  width: 100%;
  border: 1px solid #f1f1f1;
  border-radius: 3px;
  padding: 1em 1em;
}
.form .btn {
  cursor: pointer;
  background: #0071e0;
  color: #fff;
  border-radius: 3px;
  padding: 1em 1em;
  display: inline-block;
  text-align: center;
  width: 100%;
}
.top-header {
  border-bottom: 1px solid #f9f9f9;
}

.undraw {
  width: 20%;
}

.undraw img {
  max-width: 100%;
}

.bottom-pane {
  text-align: left;
}
.listed-department {
  background: #fff;
  padding: 1em;
  width: 35%;
  height: auto;
}
.listed-department li {
  display: flex;
  align-items: center;
}
.listed-department li span {
  margin-left: 0.4em;
}
.bottom-pane h1 {
  font-size: 50px;
  font-weight: bold;
  color: #000;
}
p {
  margin: 0;
}
.add-department p:first-child {
  margin-bottom: 0.6em !important;
}
.bottom-pane {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding-top: 0.9em;
}
#app,
html {
  overflow-y: hidden !important;
}
</style>

<script>
import loading from "@/components/Loading";
import logout from "@/components/Logout";
import { mapMutations } from "vuex";
import notify from "@/components/Notify";
import login from "@/components/Login";
import TopHeader from "@/components/Top-Header";
import cookies from "@/services/cookies";
import moment from "moment";
import invite from "@/components/Invite";
import truncate from "lodash";

export default {
  components: {
    notify,
    login,
    TopHeader,
    loading,
    invite,
    logout,
  },
  data() {
    return {
      answer: "",
      error: false,
      folders: [],
      group_folder_request: [],
      name: "",
      post: true,
      restrict: false,
      approved_group_folder: [],
      approved_folder: [],
      group_folder: [],
      firstname: localStorage.getItem("firstname"),
      lastname: localStorage.getItem("lastname"),
      position: localStorage.getItem("position"),
      account_type: localStorage.getItem("account_type"),
      folder_loader: false,
      viewtype: "list",
      current_tab: "request",
      current_title: "Group Folder Request",
      total_folders: 0,
    };
  },
  methods: {
    ...mapMutations([
      "SET_FILE_ACTION",
      "REMOVE_FILE_ACTION",
      "SET_DIRECTORY_CHILDREN",
      "TOGGLE_FILE_INFO",
      "SORT_DIRECTORY_CHILDREN",
      "SORT_STORED_DIRECTORY_CHILDREN",
      "SET_STORED_DIRECTORY_CHILDREN",
      "GET_DIRECTORY_CHILDREN",
      "CLOSE_FILE_INFO",
      "SET_PATH",
      "UPDATE_SLIDEIN",
      "UPDATE_SLIDEOUT",
      "UPDATE_BODY_MENU",
      "UPDATE_MENU",
      "UPDATE_TOTAL_CREATED_IMAGES",
      "UPDATE_TOTAL_CREATED_DOCUMENTS",
      "UPDATE_TOTAL_CREATED_FOLDERS",
      "SET_FIRSTNAME",
      "SET_LASTNAME",
      "SET_EMAIL",
      "SET_PHONE",
      "SET_POSITION",
      "SET_DEPARTMENT",
      "SET_COUNTRY",
      "SET_DATE_CREATED",
      "SET_ACCT_TYPE",
      "SET_ISADMIN",
      "SET_PHOTO",
      "UPDATE_TOTAL_SPACE",
      "UPDATE_DEFAULT_FOLDER",
      "UPDATE_TOTAL_USED_SPACE",
      "SET_ISTRIAL",
      "SET_ISSTAFF",
      "SET_ISSUPERADMIN",
      "SET_PATH",
      "SORT_DIRECTORY_CHILDREN",
      "SET_CURRENT_DIRECTORY",
      "HIDE_FILE_INFO",
      "SET_FILE_ACTION",
      "SET_SELECT_ALL",
      "UPDATE_USER",
      "SET_NAME",
      "SET_IS_SECURITY_QUESTION",
    ]),
    invite() {
      this.$refs.invite.load();
    },
    format_date(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    change_pic() {
      this.UPDATE_SLIDEIN(false);
      this.UPDATE_SLIDEOUT(true);
      this.UPDATE_MENU(false);
      this.UPDATE_BODY_MENU(false);

      this.$refs.pic.click();
    },
    start_upload() {
      this.$refs.startupload.load(this.$refs.pic.files[0]);
      this.$refs.pic.value = "";
    },
    slideout($evt) {
      if ($evt.target.tagName === "svg" || $evt.target.tagName === "path") {
        this.UPDATE_SLIDEIN(false);
        this.UPDATE_SLIDEOUT(true);
        this.UPDATE_MENU(false);
        this.UPDATE_BODY_MENU(false);
      } else {
        if ($evt.target.classList.contains("menubody")) {
          this.UPDATE_SLIDEIN(false);
          this.UPDATE_SLIDEOUT(true);
          this.UPDATE_MENU(false);
          this.UPDATE_BODY_MENU(false);
        }
      }
    },
    searchuser() {},
    logincall() {
      this.$refs.login.load();
    },
    check(evt) {
      if (evt.target.value !== "") {
        this.error = false;
      }
    },
    tab(tab) {
      if (tab === "approved") {
        this.group_folder_request = [];
        this.group_folder = [];
        this.current_tab = "approved";

        this.approved_folder = this.folders.filter((folder) => {
          // folder.is_approved && !folder.is_approved_by_default
          if (folder.is_approved) {
            return folder;
          }
        });

        this.total_folders = this.approved_folder.length;
        this.current_title = "Approved Group Folders";
      }

      if (tab === "all") {
        this.approved_folder = [];
        this.group_folder = [];
        this.current_tab = "all";

        this.group_folder = this.folders;
        this.total_folders = this.group_folder.length;
        this.current_title = "All Group Folders";
      }

      if (tab === "request") {
        this.approved_folder = [];
        this.group_folder = [];
        this.current_tab = "request";

        this.group_folder_request = this.folders.filter((folder) => {
          if (!folder.is_approved) {
            return folder;
          }
        });
        this.current_title = "Group Folder Request";
        this.total_folders = this.group_folder_request.length;
      }
    },
    approve(id) {
      let that = this;

      let data = {
        token: cookies.getCookie("token"),
        folder_id: id,
      };

      this.$refs.loading.load();

      this.$socket.emit("approve-folder-request", data, function (data) {
        if (data.data === true) {
          that.$refs.loading.close();

          that.folders = data.folders;
          that.group_folder_request = that.folders.filter((folder) => {
            if (!folder.is_approved) {
              return folder;
            }
          });

          that.$refs.notify.load("Folder approved successfully");
        }

        if (data.data === false) {
          that.logincall();
        }
      });
    },
    decline(id) {
      let that = this;
      let data = {
        token: cookies.getCookie("token"),
        folder_id: id,
      };

      this.$socket.emit("decline-folder-request", data, function (data) {
        if (data.data === true) {
          that.$refs.loading.close();

          that.folders = data.folders;
          that.group_folder_request = that.folders.filter((folder) => {
            if (!folder.is_approved) {
              return folder;
            }
          });

          that.$refs.notify.load("Folder declined successfully");
        }

        if (data.data === false) {
          that.logincall();
        }
      });
    },
    close() {
      this.error.message = false;
    },
    logout() {
      this.$refs.logout.logout();
    },
    user_data() {
      let data = {
        token: cookies.getCookie("token"),
      };

      let that = this;

      this.$socket.emit("get-data", data, function (data) {
        if (data.data === true) {
          that.SET_ACCT_TYPE(data.account_type);
          that.SET_ISADMIN(data.isAdmin);
          that.SET_FIRSTNAME(data.firstname);
          that.SET_LASTNAME(data.lastname);
          that.SET_EMAIL(data.email);
          that.SET_PHONE(data.phone);
          that.SET_POSITION(data.position);
          that.SET_DEPARTMENT(data.department);
          that.SET_COUNTRY(data.country ? data.country : "");
          that.SET_DATE_CREATED(data.date_created);
          that.SET_PHOTO(data.photo);
          that.UPDATE_TOTAL_SPACE(data.total_space);
          that.UPDATE_TOTAL_USED_SPACE(data.total_space_used);
          that.UPDATE_USER(data.id);
          that.SET_NAME(data.firstname + " " + data.lastname);

          that.SET_IS_SECURITY_QUESTION(data.is_security_question);

          that.SET_ISTRIAL(data.isTrial);
          that.SET_ISSTAFF(data.isStaff);
          that.SET_ISSUPERADMIN(data.isSuperAdmin);

          that.UPDATE_DEFAULT_FOLDER(data.default_folders);

          localStorage.setItem("id", data.id);
          localStorage.setItem("email", data.email);
          localStorage.setItem(
            "is_security_question",
            data.is_security_question
          );

          that.UPDATE_TOTAL_CREATED_IMAGES(data.total_created_images);
          that.UPDATE_TOTAL_CREATED_DOCUMENTS(data.total_created_documents);
          that.UPDATE_TOTAL_CREATED_FOLDERS(data.total_created_folders);
        }
      });
    },
  },
  mounted() {
    this.user_data();

    let that = this;
    if (
      cookies.getCookie("token") !== "" &&
      cookies.getCookie("token") !== null
    ) {
      let data = {
        token: cookies.getCookie("token"),
      };

      this.folder_loader = true;

      this.$socket.emit("url:auth", data, (data) => {
        if (data.data === false) {
          that.$router.push("/login");
        } else {
          that.name = data.name;

          that.$socket.emit(
            "get-group-folders",
            { token: cookies.getCookie("token") },
            function (data) {
              if (data.data === true) {
                that.folder_loader = false;
                that.folders = data.folders;
                that.group_folder_request = that.folders.filter((folder) => {
                  if (!folder.is_approved) {
                    return folder;
                  }
                });

                that.total_folders = that.group_folder_request.length;
              }
            }
          );
        }
      });
    } else {
      this.$router.push("/login");
    }
  },
};
</script>
